import type { MarkerColor, MarkerKind, RoomView } from '@concept/protocol';
import { markerInventoryLimit } from '@concept/game-core/marker-rules';

export const MARKER_COLORS: readonly MarkerColor[] = [
  'green',
  'blue',
  'red',
  'yellow',
  'black',
];

export function remainingMarkerCount(
  board: RoomView['board'],
  color: MarkerColor,
  kind: MarkerKind,
): number {
  const limit = markerInventoryLimit(color, kind);
  if (limit === null) return Number.POSITIVE_INFINITY;
  return limit - board.filter(
    (marker) => marker.color === color && marker.kind === kind,
  ).length;
}

export function availableMarkerColor(
  board: RoomView['board'],
  preferredColor: MarkerColor,
  kind: MarkerKind,
): MarkerColor | undefined {
  if (remainingMarkerCount(board, preferredColor, kind) > 0) return preferredColor;
  return MARKER_COLORS.find((color) => remainingMarkerCount(board, color, kind) > 0);
}
